<template>
<div class="flex flex-col justify-center items-center h-full text-sm bg-white p-6 gap-4 text-center">
  <img src="../../assets/img/admin/logo-sign.svg" class="w-12" alt="">
  <p>היי, אנחנו מתנצלים אך אפליקציית הלקוחות לא זמינה יותר. מעכשיו תוכלו להזמין תור מהאתר ולנהל את התורים שלכם מהאתר של בעל/ת העסק, עם חוויה חדשה ומעולה! אם לא קיבלתם הודעת SMS עם הקישור לאתר, אנא פנו לבעלת העסק :)</p>
</div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

</style>
